import './DeviceInventory.less';
import { devicesInventory } from '../../utilities/data';
import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { SchemaRenderer } from '@/schemas/components/SchemaRenderer';
import { deviceInventorySchema } from '@/schemas/deviceInventory';
import { deviceInventoryAdapter } from '@/schemas/adapters';
import {
  DeviceInfo,
  StatusInfo,
  DeviceConnectionIconInfo,
  getTranslatedLocationName,
} from '@/Components/Common/DeviceInventoryTiles';
import { HSCard } from '@/Components/Common/HSWidget';

const { device_types } = devicesInventory;

const DeviceInventoryList = ({
  device,
  isExpanded,
  showModal,
  deviceStatus,
  timezone,
  connectionStatus,
  loginUserTimeformat,
  userConfig,
  selectedLanguage,
}) => {
  const trans = useSelector(translator);
  const isDeviceExpanded =
    device_types?.smart_camera_devices?.models?.includes(device?.modelnumber) || isExpanded;

  const handleClick = () => {
    showModal(device);
  };

  const data = deviceInventoryAdapter({
    device,
    userConfig,
    selectedLanguage,
    trans,
    timezone,
    connectionStatus,
    loginUserTimeformat,
    deviceStatus,
  });

  return (
    <HSCard
      className={`device-card ${
        device_types?.smart_camera_devices?.models?.includes(device?.modelnumber)
          ? 'hc200-device-card'
          : ''
      }`}
      onClick={handleClick}
      content={
        <div className="device-card-body">
          <SchemaRenderer
            schema={deviceInventorySchema[isDeviceExpanded ? 'expanded' : 'list']}
            data={data}
          />
        </div>
      }
    />
  );
};

export { DeviceInfo, StatusInfo, DeviceConnectionIconInfo, getTranslatedLocationName };

export default DeviceInventoryList;
